import type { SearchVehicle } from '../types'

export const vinLastSix = ({ vin }: SearchVehicle): string => vin?.slice(-6) || ''
